import React, { useState } from "react";
import cn from "classnames";
import { GoogleMap } from "@react-google-maps/api";
// import { usePostHog } from "posthog-js/react";
// import { EmitAnalyticsEvent } from "module/analytics/application/EmitAnalyticsEvent";
import { formatNumber, toFixed2 } from "utils/formators";
import { SuggestedRoute } from "module/eddm/dto";
import { DeleteIcon } from "static/media/delete-icon";
import { ResidencesIcon } from "components/icons/components/ResidencesIcon";
import { handleHoverSelectedMissionUpdate } from "components/audience-map/utils";
import { StarIcon } from "components/icons/components/Star";
import { Check } from "lucide-react";
import { useStore } from "store";

interface SuggestionRouteCardProps {
  route: SuggestedRoute;
  className: string;
  handleRouteDelete: (route: SuggestedRoute) => void;
  handleRouteSelect: (route: SuggestedRoute) => void;
  googleMap: GoogleMap | null;
}

export const SuggestedRouteCard = ({
  route,
  className,
  handleRouteDelete,
  handleRouteSelect,
  googleMap,
}: SuggestionRouteCardProps) => {
  const {
    // user: { id: userId },
    // client: { name: clientName },
    campaign: { isSubmitted },
    costsCalculationData: { costPerFlyer },
  } = useStore();
  const [isHovered, setIsHovered] = useState(false);
  // const posthog = usePostHog();
  // const posthogEventTracker = new EmitAnalyticsEvent(posthog);

  const totalAddresses = route?.properties ? route?.properties?.HOME_COUNT + route?.properties?.APT_COUNT : 0;

  return (
    <div
      className={cn(
        "relative box-border flex h-[66px] w-full cursor-pointer flex-col items-center justify-center border border-solid border-[#E2E2FC] bg-[#F9F9FF] px-2 py-[5px] dark:border-border dark:bg-card",
        { [className]: !!className }
      )}
      onMouseOver={() => {
        setIsHovered(true);
        handleHoverSelectedMissionUpdate({ mapInit: googleMap, hoveredMission: route._id });
      }}
      onMouseLeave={() => {
        setIsHovered(false);
        handleHoverSelectedMissionUpdate({ mapInit: googleMap, hoveredMission: null });
      }}
    >
      <div className="flex min-h-[30px] w-full items-center justify-between">
        <div
          className={cn(
            "relative flex w-fit max-w-[90%] items-center overflow-hidden px-[5px] pt-[2px] transition-colors duration-[400ms] before:absolute before:inset-0 before:z-0 before:bg-[#4F5B94] before:transition-transform before:duration-[400ms] before:ease-out before:content-['']",
            isHovered
              ? "text-white before:translate-x-0"
              : "text-[#222336] before:-translate-x-[101%] dark:text-foreground"
          )}
        >
          <span className="relative z-[1] flex items-center">
            {route.properties.ZIP} - {route.properties.CROUTE}
          </span>
        </div>
        <div className="flex items-center">
          <button className="flex h-6 w-6 cursor-pointer items-center justify-center rounded-full border border-solid border-border bg-transparent text-foreground">
            <DeleteIcon
              disabled={isSubmitted}
              width={"16"}
              height={"16"}
              stroke="currentColor"
              onClick={(e: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
                e.preventDefault();
                e.stopPropagation();
                if (isSubmitted) return;
                // posthogEventTracker.run({
                //   eventName: `Deleted single route`,
                //   userId: userId,
                //   clientName,
                //   device: navigator.userAgent,
                // });
                handleRouteDelete(route);
              }}
            />
          </button>
          <button
            data-cy={`suggestedRouteSelect-${route._id}`}
            className="ml-[5px] flex h-6 w-6 cursor-pointer items-center justify-center rounded-full border border-solid border-primary bg-primary text-primary-foreground"
            onClick={() => handleRouteSelect(route)}
          >
            <Check className="h-[15px] w-[15px]" />
          </button>
        </div>
      </div>
      <div className="mt-[5px] flex w-full items-center justify-between text-[14px]">
        <div className="flex items-center text-muted-foreground [&_svg]:mr-[2px]">
          <StarIcon stroke="currentColor" />
          <span>{route.suitabilityScore}%</span>
        </div>
        <div className="flex items-center text-muted-foreground [&_svg]:mr-[2px]">
          <ResidencesIcon stroke="currentColor" />
          <span>{formatNumber(totalAddresses)}</span>
        </div>
        <div className="flex items-center">
          <span className="mr-[5px] text-[12px] text-muted-foreground">Cost</span>
          <span className="font-semibold text-muted-foreground">
            ${formatNumber(toFixed2(costPerFlyer * totalAddresses))}
          </span>
        </div>
      </div>
    </div>
  );
};
